module.exports = "/_next/static/images/logo-horizontal-white-d957bbf9bd5af45f89c7d1d11657c2dc.svg";